(function () {


window.note = function(){
    var a = arguments;
    // return console.log(...arguments);
}

window.addEventListener("hashchange", function(e){
    window.note("===== hashchange ====================")
    window.note(e.target.location.hash)
})


    window.isInitialLoad = true;

    const obj = {};
    if(window.location.hash.split('?').length>1){
        window.location.hash.split('?')[1].split('&').forEach((kvp) => {
            const pair = kvp.split('=');
            obj[pair[0]] = pair[1];
        });
    }
    let s_q = obj.hasOwnProperty("q") ? decodeURI(obj.q) : ""
    let s_tab = obj.hasOwnProperty("tab") ? decodeURI(obj.tab) : ""
    let s_page = obj.hasOwnProperty("page") ? "Page "+decodeURI(obj.page) : ""

    window.dataLayer = Object.assign({}, window.dataLayer, {
        searchInfo: {
            searchTerm: s_q,
            filters: s_tab,
            sortBy: s_page,
            results: 0,
            contentType: '',
            refinements: ''
        }
    });
    if (typeof (_satellite) !== 'undefined') {
      _satellite.track("hashChange");
    }


    window.note('===== init =========================')
    window.note(window.dataLayer.searchInfo)
    window.note("_satellite",typeof (_satellite))
    window.note("window.isInitialLoad",window.isInitialLoad)

    angular
        .module("app")
        .controller("SearchResultsController", SearchResultsController)
        .filter("showResultItem", showResultItem);

    function showResultItem() {
        return function (arr, obj) {
            // identify which result items to display
            return arr.filter(item => {
                let showThis = parseInt(item.index) >= (obj.currentPage - 1) * obj.pageSize
                    && parseInt(item.index) < (obj.currentPage - 1) * obj.pageSize + obj.pageSize;
                return showThis;
            });
        }
    }

    SearchResultsController.$inject = ["$scope", "$state", "$stateParams", "BucketService", "DataService", "PageService", "SearchService", "appConfig"];

    function SearchResultsController($scope, $state, $stateParams, BucketService, DataService, PageService, SearchService, appConfig) {

        $scope.useAnalyticsTracking = !!window.useAnalyticsTracking;

        //https://github.com/airbnb/javascript
        window._searchResultsController = $scope;
        window._src = $scope;

        // ======================================================
        // load services
        // ======================================================
        DataService.loadPropsAndMethods($scope);
        BucketService.loadPropsAndMethods($scope);
        PageService.loadPropsAndMethods($scope);
        SearchService.loadPropsAndMethods($scope);


        // ======================================================
        // `No results` message
        // ======================================================
        $scope.currentSearch.noResults = '';
        $scope.currentSearch.didSearch = false;
        $scope.showNoResults = () => {
            return (
                !$scope.currentSearch.searchResults.length &&
                !!$scope.searchTerm.length &&
                $scope.currentSearch.didSearch
            )
        };

        // for search results total number
        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        // ======================================================
        // $scope.onSearchComplete()
        // ======================================================
        // TODO: remove unused code: analytics, etc.
        $scope.onSearchComplete = (results) => {

            $scope.currentSearch.shroud = false;
            if (results.success && $scope.views.length) {
                // hydrate $scope.currentSearch
                $scope.aggregateResults();

                const resultsCount = numberWithCommas(parseInt($scope.currentSearch.resultsCount)) + ($scope.currentSearch.resultsCount === 10000? '+': "") ;
                let maxPages = Math.ceil($scope.currentSearch.resultsCount / $scope.currentSearch.pageSize);
                window._dev_maxPages = maxPages;
                const _searchResultsCountMessage = typeof (appConfig.searchParams.searchResultsCountText) !== "undefined" ? appConfig.searchParams.searchResultsCountText : "results for";
                $scope.currentSearch.searchResultsCountMessage = `${resultsCount} ${_searchResultsCountMessage} ${$scope.searchTerm}`;
                $scope.currentSearch.noResults = typeof (appConfig.searchParams.noSearchResultsMessage) !== "undefined" ? appConfig.searchParams.noSearchResultsMessage : "Try one of the other tabs above or enter a different search term."

                $scope.currentSearch.didSearch = true;
                $scope.setPageList();
                $scope.$apply();


                //---------------------------------------------------------------------------------
                // correct 'currentPage' when GSA changes total search hit count changes.
                // GSA consistently over estimates the search result total until it comes
                // to the end of the actual total. When that total is updated to a smaller
                // amount, the app needs to adjust.
                //---------------------------------------------------------------------------------
                if ($scope.currentSearch.currentPage > maxPages && maxPages > 0) {
                    $scope.setNewPage({
                        index: maxPages,
                        current: false
                    })
                }
                else {
                    //$(".bucket-index.selected").focus();
                    $("#search-btn").focus();
                }

            }
            else if (!results.success) {
                try {
                    $scope.currentSearch.errorMessage = `Error: '${results.content.msg}' ${results.content.view.name} [${results.content.viewIndex}]`;
                    $scope.$apply();
                }
                catch (e) {
                    $scope.currentSearch.errorMessage = `Error: ${e}`
                }
            }

            $scope.currentSearchToDisplay()

            $scope.$apply();

            // new per S.T., 180330
            let currentBucketIndex = $scope.v ? $scope.v : 0;
            let currentPageIndex = $scope.pageIndex;



            
            window.dataLayer = Object.assign({}, window.dataLayer, {
                searchInfo: {
                    searchTerm: $scope.searchTerm,
                    filters: $scope.buckets[currentBucketIndex].name,
                    sortBy: "Page " + currentPageIndex,
                    results: parseInt($scope.currentSearch.resultsCount.toString().replace(/\D/g,'')),
                    contentType: "",
                    refinements: ""
                }
            });
            window._dev_pageIndex = $scope.pageIndex;
            window._dev_displaySearch = $scope.displaySearch;
            

            // new per S.T., 180709
            if (!window.isInitialLoad && typeof (_satellite) !== 'undefined') {
                _satellite.track("hashChange");
            }
            window.isInitialLoad = false;

            window.note('===== onSearchComplete ====================')
            window.note(window.dataLayer.searchInfo)
            window.note("_satellite",typeof (_satellite))
            window.note("window.isInitialLoad",window.isInitialLoad)

        }; // $scope.onSearchComplete

        // ======================================================
        // $scope.onSetPage()
        // ======================================================
        $scope.onSetPage = (page) => {
            if (!$scope.searchMultipleViews && $scope.views.length == 1) {
                $scope.currentSearch.pageSize = $scope.buckets[$scope.views[0]].pageSize;
            }

            let pageSize = $scope.currentSearch.pageSize;
            let accumulatedCount = $scope.currentSearch.searchResults.length;
            let expectedTotalCount = $scope.currentSearch.resultsCount;
            let start = (page.index - 1) * pageSize + 1;
            let recordsToFetch = (expectedTotalCount <= accumulatedCount && accumulatedCount > 0) ? 0 : Math.max(0, start + pageSize - accumulatedCount);

            // TODO: remove this - for dev only
            $scope._onPageSetInfo = {
                pageSize: pageSize,
                accumulatedCount: accumulatedCount,
                expectedTotalCount: expectedTotalCount,
                start: start,
                recordsToFetch: recordsToFetch
            };

            $scope.currentSearch.fetchSize = recordsToFetch;
            $scope.currentSearch.fetchSize = pageSize;
            $scope.currentSearch.startRecord = start;

            if (recordsToFetch > 0) {
                $scope.currentSearch.shroud = true;
                setTimeout(function () { }, 0)
                $scope.performSearch();
            }
            else {
                $scope.currentSearchToDisplay()
            }

        }; // $scope.onSetPage


        // ======================================================
        // $scope.doSearch()
        // ======================================================
        $scope.doSearch = () => {
            let v = $scope.views.length ? $scope.views.join(',') : '0';
            let t = $scope.buckets[v].name;
            const routeParams = {
                q: $scope.searchTerm,
                v: v,
                tab: t,
                page: 1
            };
            if (!!$scope.searchTerm.length) {
                $state.go($scope.route.name, routeParams)
            }
        };


        // ======================================================
        // $scope.setSearchGsaQuery() : add synonyms to query
        // ======================================================
        $scope.setSearchGsaQuery = () => {
            let gsaSearchTermData = $scope.enSynonyms.getSearchTermSynonymData($scope.searchTerm);
            $scope.searchGsaQuery = gsaSearchTermData.searchStringWithSynonyms;
        };


        // ======================================================
        // dom element class utility functions
        // ======================================================
        function addClass(e, c) {
            const classes = e.className.split(' ')
            const index = classes.indexOf(c);

            if (index == -1) {
                classes.push(c)
                classes.sort(function (a, b) { return a > b; })
                e.className = classes.join(' ')
            }
        }
        function removeClass(e, c) {
            const classes = e.className.split(' ');
            const index = classes.indexOf(c);
            if (index > -1) {
                classes.splice(index, 1);
                classes.sort(function (a, b) { return a > b; })
                e.className = classes.join(' ')
            }
        }
        function swapClass(e, c1, c2) {
            removeClass(e, c2);
            addClass(e, c1);
        }


        // ======================================================
        // dom elements
        // ======================================================
        let _w = {};
        _w.searchTermInputContainer = document.getElementById('search-term-input-container');
        _w.searchTerm = document.getElementById('searchTerm');
        _w.searchLabel = document.getElementById('esri-search-label');
        _w.searchResultsContainer = document.getElementById('search-results-container');

        _w.esriSearchMeasureText = document.getElementById('esri-search-measure-text');
        _w.esriSearchMeasureBlue = document.getElementById('esri-search-measure-blue');

        // ======================================================
        // dom element classes
        // ======================================================
        const searchTerm_focused = 'search-term-focused';
        const searchTerm_typed = 'search-term-typed';

        // ======================================================
        // set search term label class attribute
        // ======================================================
        function setSearchTermLabel(_val) {
            const val = _val || "";
            if (!!val.length) {

                addClass(_w.searchTermInputContainer, searchTerm_typed)
                setTimeout(function () {

                    addClass(_w.searchLabel, 'transition')
                    setTimeout(function () {
                        removeClass(_w.searchLabel, 'transition')
                    }, 500) // let transition finish beforehand

                    addClass(_w.searchLabel, 'small-label')

                }, 10)

                removeClass(_w.searchLabel, 'large-label')
            }
            else {
                removeClass(_w.searchTermInputContainer, searchTerm_typed)
                swapClass(_w.searchLabel, 'large-label', 'small-label')
            }
        }

        // ======================================================
        // set blue line under search term
        // ======================================================
        function measureSearchInputString(_str) {
            const str = getMeasureSearchTerm(_str) || "";
            const strToMeasure = typeof str != 'undefined' ? str : $scope.searchTerm;
            _w.esriSearchMeasureText.innerHTML = strToMeasure.replace(/ /g, "&nbsp;");
            const width = !!_w.esriSearchMeasureText.clientWidth ? (_w.esriSearchMeasureText.clientWidth + 3) + "px" : 0;
            _w.esriSearchMeasureBlue.setAttribute("style", "width:" + width);
        }

        // ======================================================
        // dom element state/class change functions
        // ======================================================
        _w.searchTerm.onfocus = function () {
            addClass(_w.searchTermInputContainer, searchTerm_focused)
            addClass(_w.esriSearchMeasureBlue, "transition")
            measureSearchInputString($scope.searchTermInput);
        };

        _w.searchTerm.addEventListener("blur", function (e) {
            removeClass(_w.searchTermInputContainer, searchTerm_focused)
            removeClass(_w.esriSearchMeasureBlue, "transition")
        })

        _w.searchTerm.addEventListener("input", function (e) {
            // malicious characters have been remove (already) from $scope.searchTerm 
            // uncomment the line below to remove malicious characters on input -> $scope.searchTermInput
            // e.target.value = validateSearchTerm(e.target.value);
            validateSearchTerm(e.target.value);
            const val = getMeasureSearchTerm(e.target.value);
            setSearchTermLabel(val)
            measureSearchInputString(val);
        })

        // ======================================================
        // $scope.searchGlassIconEvent()
        // ======================================================
        $scope.searchGlassIconEvent = (e) => {
            $scope.searchTerm = validateSearchTerm($scope.searchTermInput);
            $scope.doSearch();
        };

        // ======================================================
        // $scope.searchKeyEvent()
        // ======================================================
        $scope.searchKeyEvent = (e) => {
            const keyCode = e.keyCode ? e.keyCode : e.which;
            measureSearchInputString($scope.searchTermInput);
            if (keyCode == 13) {
                $scope.searchTerm = validateSearchTerm($scope.searchTermInput);
                //$scope.q = $scope.searchTerm;
                e.preventDefault();
                $scope.doSearch();
            }
        };

        // ======================================================
        // function validateSearchTerm: remove special characters
        // ======================================================

        const validateSearchTerm = function _s_validateSearchTerm(value) {
            const _blueLine = function __blueLine() {
                _w.esriSearchMeasureBlue.classList.add("esri-search-measure-blue")
                _w.esriSearchMeasureBlue.classList.remove("esri-search-measure-red")
            }

            const _redLine = function __redLine() {
                _w.esriSearchMeasureBlue.classList.add("esri-search-measure-red")
                _w.esriSearchMeasureBlue.classList.remove("esri-search-measure-blue")
            }
            const cleanValue = getCleanSearchTerm(value)
            if (cleanValue != value) {
                _redLine()
            }
            else {
                _blueLine()
            }
            //return value
            return cleanValue.trim();
        }

        const getCleanSearchTerm = function _s_getCleanSearchTerm(value) {
            if (value) {
                return (value.replace(/[()<>\&\"\\\/]+/g, ""))
            }
            return "";
        }

        const getMeasureSearchTerm = function _s_getMeasureSearchTerm(value) {
            if (value) {
                const _v = value.trim()
                return (_v.replace(/[()\&<>\"\'\\\/]/g, "_"))
            }
            return "";
        }


        // ======================================================
        // Init - starting with new search term or new search view (bucket)
        // ======================================================

        $scope.searchInputLabel = typeof (appConfig.searchParams.searchInputLabel) !== "undefined" ? appConfig.searchParams.searchInputLabel : "Search Esri";
        $scope.resultsPageButtonText = appConfig.searchParams.resultsPageButtonText;
        $scope.route = $state.current;
        $scope.showNoResultsMessage = false;
        $scope.arcgisTypeIcons = appConfig.arcgisTypeIcons;
        $scope.arcgisThumbnailPlaceholders = appConfig.arcgisThumbnailPlaceholders;
        $scope.arcgisDotComAltNextStart = 0;

        $scope.searchTerm = validateSearchTerm($stateParams.q) || '';
        $scope.searchTermInput = $stateParams.q || '';
        _w.esriSearchMeasureText.innerHTML = getMeasureSearchTerm($stateParams.q);

        //$scope.q = $scope.searchTerm;
        $scope.s = $stateParams.s || 1;
        $scope.v = $stateParams.v || '';
        $scope.f = $stateParams.f || '';

        if ($scope.searchTerm.length) {
            swapClass(_w.searchLabel, 'small-label', 'large-label')
        }
        else {
            swapClass(_w.searchLabel, 'large-label', 'small-label')
        }

        $scope.start = $scope.s;
        $scope.views = ($stateParams.v) ? $stateParams.v.split(',') : [];
        $scope.filter = $stateParams.f;
        $scope.pageIndex = $stateParams.page || 1;

        // ---------------------------------------------
        // Reset to one view when necessary
        // Only one view when $scope.searchMultipleViews == false;
        // ---------------------------------------------
        if (!$scope.searchMultipleViews && $scope.views.length > 1) {
            let v = $scope.views.length ? $scope.views.join(',') : '0';
            let t = $scope.buckets[v].name;
            const routeParams = {
                q: $scope.searchTerm,
                v: $scope.views[0],
                tab: t,
                page: 1
            };
            $state.go($scope.route.name, routeParams)
        }

        $scope.resultTargetWindow = "";
        $scope.initBuckets();

        let pageIndex = $stateParams.page || 1; // initial value

        // ======================================================
        // start search
        // ======================================================



        if ($scope.searchTerm != $scope.searchTermInput) {
            setTimeout(function () {
                measureSearchInputString($scope.searchTerm);
            }, 300)
        }
        //else 
        if (!!$scope.searchTerm.length) {

            let currentPageIndex = 1;
            let currentBucketIndex = $scope.v ? $scope.v : 0;

            // search term synonyms etc.
            $scope.setSearchGsaQuery();

            // set page of current search if possible, and perform search and
            if (!isNaN(pageIndex)) {
                currentPageIndex = pageIndex;
                $scope.setPage({ index: parseInt(pageIndex), current: false })
            }
            else {
                $scope.setPage({ index: 1, current: false })
            }

            // set search results page list under results
            $scope.setPageList();

            // Set search input UI
            addClass(_w.searchTermInputContainer, searchTerm_typed);
            _w.esriSearchMeasureBlue.setAttribute("style", "width:0");
            measureSearchInputString($scope.searchTerm);

            const currentPage = $scope.pageNav.pages.find(page => {
                return page.current;
            }) || { index: 0, current: true };

            const currentTab = $scope.buckets.find(bucket => {
                return bucket.selected;
            });

        } // if($scope.searchTerm.length)

        addClass(_w.searchResultsContainer, 'results-loaded')

        if ($scope.searchTerm.length) {
            document.getElementById('esri-search-label').classList.add("small-label");
        }

        // ======================================================
        // disable sitecore postback form (id=Form1)
        // disable postback form submit function while search term input is focused
        // pressing <Enter> should intiate new search, not reload page.
        // ======================================================
        setTimeout(function () {
            if (!!document.getElementById("Form1")) {
                const Form1 = document.getElementById("Form1")
                const searchTerm = document.getElementById("searchTerm")
                Form1.setAttribute("onsubmit", "return false");
                setTimeout(function () {
                    searchTerm.onfocus = function () {
                        Form1.setAttribute("onsubmit", "return false");
                    }
                    searchTerm.onblur = function () {
                        setTimeout(function () {
                            //Form1.setAttribute("onsubmit","return false");
                            Form1.setAttribute("onsubmit", "return true");
                        }, 100)
                    }
                }, 10)
            }
        }, 1000);
    }
    // ======================================
    // End SearchResultsController
    // ======================================
})();
